import { useState } from "react";
import { ReactComponent as PdfIcon } from "../../assets/image/svg/pdfIcon.svg";
import { analytics, logLoadTrace } from "../../firebase";
import CircularProgress from "@mui/material/CircularProgress";
import { createAndDownloadInvoicePdf, customStyle } from "../viewOrder/ViewOrderUtils";
import { logEvent } from "firebase/analytics";
import { openPopup } from "../../stateManagement/actions/popupActions";
import { EnvironmentRegistry } from "../../services/registry/environmentRegistry";
import { getAccessToken } from "../../services/authenticationService";
import "./DeliveryInvoiceDetails.css";
import { generateInvoiceIRN } from "../../services/manageOrderService";

const InvoicePrint = (props: { invoiceNumber: string, allowEInvoice: boolean }) => {
    const [isLoading, setIsLoading] = useState(false);
    const ACCESS_TOKEN = getAccessToken() ?? "";


    const handlePrintInvoice = async (viewInvoice: boolean = false) => {
        setIsLoading(true);
        try {
            const blobKey = (await createAndDownloadInvoicePdf([props.invoiceNumber]))[0];
            if (!blobKey || !ACCESS_TOKEN) {
                console.error("Invalid URL or access token.");
                openPopup("Error", "Invalid URL or access token.");
                return;
            }
            const fileMetaId = blobKey.split("/").pop();
            const serverUrl = EnvironmentRegistry.getServerUrl();
            const pdfUrl = viewInvoice
                ? `${serverUrl}/v1/media/viewPdf/${fileMetaId}?access_token=${ACCESS_TOKEN}`
                : `${blobKey}?access_token=${ACCESS_TOKEN}`;
            window.open(pdfUrl, "_blank");
            logEvent(analytics, "secondary_invoice_report_downloaded", {
                "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
                "invoice_id": props.invoiceNumber ?? null,
                "download_format": "pdf",
            });
        } catch (e: any) {
            logEvent(analytics, "secondary_invoice_download_failed", {
                "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
                "invoice_id": props.invoiceNumber,
                "error_reason": e.toString(),
            });
            openPopup("Error", "Error while creating invoice pdf");
        }
        setIsLoading(false);
    };

    const handlePushToEInvoice = async () => {
        try {
            const res = await generateInvoiceIRN(props.invoiceNumber);
            const data = res?.data;

            if (`status` in data) {
                console.error(data?.errorMessage);
                openPopup("Error", data?.errorMessage ?? `Some error occured while e-invoicing`);
            } else if (data?.[`Status`] === 0) {
                const errors: string | any[] = Array.isArray(data?.[`ErrorDetails`])
                    ? data?.[`ErrorDetails`]
                    : `Some error occured while e-invoicing`;
                openPopup("Error", errors.toString());
                console.error(errors);
            } else if (data?.[`Status`] === `ACT`) {
                openPopup(
                    "Success",
                    data?.errorMessage ?? `Invoice No. ${props.invoiceNumber} pushed to e-invoice.`,
                    () => { }
                );
            }
        } catch (e) {
            openPopup("Error", `Some error occured while e-invoicing`);
        } finally {
        }
    };

    return (
        <div className="delivery-invoice-print-container">
            <button
                className="delivery-invoice-print"
                onClick={() => {
                    logLoadTrace(handlePrintInvoice, "secondary_print_invoice_download_time");
                }
                }
                disabled={isLoading}
            >
                <span>Print Invoice</span>&nbsp;
                <span style={{ width: 20 }}>
                    {isLoading ? (
                        <CircularProgress
                            style={{
                                ...customStyle,
                                color: "#1D8DED",
                                height: 15,
                                width: 15,
                            }}
                        />
                    ) : (
                        <PdfIcon />
                    )}
                </span>
            </button>
            {props.allowEInvoice && <button
                className={"submit-button-delivery"}
                onClick={handlePushToEInvoice}
            >
                <span className="submit-button-delivery-text">
                    Push to e-Invoice
                </span>
            </button>}


        </div>
    );

}

export default InvoicePrint;